"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./TrialSummary.scss");
var _TrialMethods = require("./TrialMethods.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TrialSummary = _ref => {
  let {
    content
  } = _ref;
  const {
    eyebrow,
    productName,
    productNameIcon,
    body,
    bullets,
    durationLabel,
    duration,
    operatingSystemLabel,
    operatingSystem
  } = content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "trial-summary"
  }, eyebrow && /*#__PURE__*/_react.default.createElement("h1", {
    className: "trial-summary--eyebrow"
  }, eyebrow), /*#__PURE__*/_react.default.createElement("div", {
    className: "trial-summary--product"
  }, productNameIcon?.src && /*#__PURE__*/_react.default.createElement("img", {
    className: "trial-summary--product--img",
    src: productNameIcon?.src,
    alt: productNameIcon?.alt
  }), productName && /*#__PURE__*/_react.default.createElement("h3", {
    className: "trial-summary--product--name"
  }, productName)), body && /*#__PURE__*/_react.default.createElement("p", {
    className: "trial-summary--text"
  }, body), bullets && /*#__PURE__*/_react.default.createElement("ul", {
    className: "trial-summary--bullets"
  }, (0, _TrialMethods.formatBullets)(bullets)), durationLabel && /*#__PURE__*/_react.default.createElement("h1", {
    className: "trial-summary--eyebrow"
  }, durationLabel), duration && /*#__PURE__*/_react.default.createElement("p", {
    className: "trial-summary--spec-text"
  }, duration), operatingSystemLabel && /*#__PURE__*/_react.default.createElement("h1", {
    className: "trial-summary--eyebrow"
  }, operatingSystemLabel), operatingSystem && /*#__PURE__*/_react.default.createElement("p", {
    className: "trial-summary--spec-text"
  }, operatingSystem));
};
var _default = TrialSummary;
exports.default = _default;